import { render, staticRenderFns } from "./DefaultEmptyConfigEditor.vue?vue&type=template&id=66ef93d8&scoped=true&"
import script from "./DefaultEmptyConfigEditor.vue?vue&type=script&lang=js&"
export * from "./DefaultEmptyConfigEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef93d8",
  null
  
)

export default component.exports